import Button from '@/shared/Button/Button';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { useContext } from 'react';

export default function ComicButtons({ activity }) {
  const globalContext = useContext(GlobalContext);
  const pdfFile = activity.data?.pdfFile;
  const pdfFileAvailable =
    pdfFile &&
    ((activity?.free && !globalContext.state.user) ||
      (globalContext.state.user?.teacher &&
        globalContext.state.isSubscriptionActive) ||
      globalContext.state.user?.admin);

  return pdfFileAvailable ? (
    <Button type="primary" href={pdfFile} target="_blank" rel="noreferrer">
      Download as PDF
    </Button>
  ) : null;
}
